var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"csfg__loading"},[_c('span',[_c('img',{attrs:{"src":"https://player.carsalesgallery.com/icons/loader.svg","alt":"Ładowanie..."}}),_c('span',{staticClass:"csfg__loading__precentage"},[_vm._v(_vm._s(_vm.precentage)+"%")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }